import { useTranslation } from 'react-i18next'
import CoachSectionCard from '../ui/CoachSectionCard'
import CoachBodyMetricsPanel from './CoachBodyMetricsPanel'
import RecoveryDebtCard from './RecoveryDebtCard'
import type { CoachHealthSummary } from '../../lib/coachHealthTypes'
import { SkeletonCard } from '../ui/Skeleton'

type CoachBodyCardProps = {
  summary: CoachHealthSummary | null
  loading: boolean
  connecting: boolean
  onConnecting: () => void
  onRefresh: (sync?: boolean) => void
}

const CoachBodyCard = ({ summary, loading, connecting, onConnecting, onRefresh }: CoachBodyCardProps) => {
  const { t } = useTranslation()

  if (loading && !summary && !connecting) {
    return (
      <div role="status">
        <SkeletonCard />
      </div>
    )
  }

  if (!summary?.has_device_connected && !connecting) {
    return null
  }

  const debt = summary?.recovery_debt
  const visibleMetrics = summary?.visible_metrics ?? []
  const showRecoveryDebt = visibleMetrics.includes('recovery_debt')

  return (
    <CoachSectionCard title={t('coach.sections.body')} icon="monitor_heart" defaultExpanded>
      {showRecoveryDebt && summary ? (
        <RecoveryDebtCard
          embedded
          debtScore={Number(debt?.debt_score ?? 0)}
          consecutiveDays={Number(debt?.consecutive_debt_days ?? 0)}
          trend={(debt?.trend as 'accumulating' | 'recovering' | 'stable') ?? 'stable'}
          hasMetricData={summary.has_metric_data}
        />
      ) : null}
      <CoachBodyMetricsPanel
        summary={summary}
        loading={loading}
        connecting={connecting}
        onConnecting={onConnecting}
        onRefresh={onRefresh}
        embedded
      />
    </CoachSectionCard>
  )
}

export default CoachBodyCard
